<template>
  <div class="preloading-skeleton">
    <div class="preloading-skeleton__results-section">
      <ul class="preloading-skeleton__results-list">
        <li
          v-for="resultItem in 4"
          :key="resultItem"
          class="single-result-item preloading-skeleton__single-result-item"
        >
          <div class="single-result-item__image-container">
            <div
              class="single-result-item__image"
              :style="{ width: lodashRandom(50, 90) + 'px', height: lodashRandom(35, 65) + 'px' }"
            ></div>
          </div>

          <div class="single-result-item__title-n-id">
            <div class="single-result-item__title" :style="{ width: lodashRandom(90, 180) + 'px' }"></div>
            <div class="single-result-item__id"></div>
          </div>

          <div class="single-result-item__product-type-container">
            <div class="product-type single-result-item__product-type">
              <div class="product-type__icon"></div>
              <div class="product-type__text"></div>
            </div>
          </div>

          <div class="single-result-item__right-container">
            <ul class="single-result-item__articles-list">
              <li v-for="article in 4" :key="article" class="single-article single-result-item__single-article">
                <div class="single-article__image-container">
                  <div
                    class="single-article__image"
                    :style="{ width: lodashRandom(50, 70) + 'px', height: lodashRandom(30, 50) + 'px' }"
                  ></div>
                </div>
                <div class="single-article__color"></div>
              </li>
            </ul>
          </div>

          <div class="single-result-item__info-button"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import lodashRandom from 'lodash/random';

export default {
  name: 'skeleton-placeholder',

  methods: {
    lodashRandom,
  },
};
</script>

<style scoped lang="scss">
@import '@styles/variables.scss';
@import '@styles/mixins.scss';

@mixin flexCenter {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

// ============================================================================
// Preloading skeleton
.preloading-skeleton {
  &__results-section {
  }

  &__results-list {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  &__single-result-item {
  }
  .single-result-item {
    @include flexCenter;
    height: 11.5rem;
    padding-right: 2.5rem;
    justify-content: space-between;
    position: relative;

    &::before {
      content: '';
      width: 100%;
      height: 1px;
      position: absolute;
      inset: auto auto 0 0;
      font-size: 0;
      line-height: 0;
      background: rgba($c-dark, 0.1);
    }

    &:last-child::before {
      display: none;
    }

    &__image-container {
      @include flexCenter;
      width: 11rem;
    }

    &__image {
      @include skeletonPlaceholder;
    }

    &__title-n-id {
      @include flexCenter;
      width: 27rem;
      height: 100%;
      flex-direction: column;
    }

    &__title {
      @include skeletonPlaceholder;
      width: 11rem;
      height: 1.5rem;
      margin-bottom: 0.5rem;
    }

    &__id {
      @include skeletonPlaceholder;
      width: 5.5rem;
      height: 0.8rem;
    }

    &__product-type-container {
      @include flexCenter;
      width: 5.5rem;
    }

    &__product-type {
    }
    .product-type {
      @include flexCenter;
      flex-direction: column;

      &__icon {
        @include skeletonPlaceholder;
        width: 2rem;
        height: 1.7rem;
        margin-bottom: 3px;
      }
      &__text {
        @include skeletonPlaceholder;
        width: 4rem;
        height: 0.6rem;
      }
    }

    &__right-container {
      @include flexCenter;
      min-width: 50%;
      flex-grow: 1;
      justify-content: flex-end;
    }

    &__articles-list {
      @include flexCenter;
      padding: 0 0 0 6rem;
      margin: 0;
      flex-grow: 1;
      justify-content: flex-start;
      list-style: none;
    }

    &__single-article {
      margin-right: 1.6rem;
    }
    .single-article {
      @include flexCenter;
      flex-direction: column;

      &__image-container {
        @include flexCenter;
        width: 7rem;
        height: 5rem;
        margin-bottom: 4px;
      }
      &__image {
        @include skeletonPlaceholder;
      }
      &__color {
        @include skeletonPlaceholder;
        width: 7.5rem;
        height: 2rem;
        border-radius: 10rem;
      }
    }

    &__counter {
    }

    &__info-button {
      @include skeletonPlaceholder;
      width: 1rem;
      height: 1.8rem;
    }
  }
}
</style>
